// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__L70ZY","col":"styles_col__ruwcA"};